import script from "./TextInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextInput.vue?vue&type=script&setup=true&lang=ts"

import "./TextInput.vue?vue&type=style&index=0&id=a064bada&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a064bada"]])

export default __exports__